import React from 'react';

interface EditableCellProps {
  value?: string | null;
}

export const EditableCell: React.FC<EditableCellProps> = ({ value }) => {
  return <div style={{ whiteSpace: 'pre-line' }}>{value ?? null}</div>;
};
